import Swiper from "swiper";
import { Navigation, Thumbs } from 'swiper/modules';
import { classExists } from "../helper/class-exists";
const playHide = (btn, iframe, iframeEl) => {
  btn.classList.add("hide");
  iframeEl.classList.remove("not-playing");
  let src = iframe.getAttribute("src");
  if (!src.includes("autoplay=1")) {
    const newSrc = src.includes("?")
      ? src + "&autoplay=1"
      : src + "?autoplay=1";
    iframe.setAttribute("src", newSrc);
  }
};

const iframeHandler = (el) => {
  const button = el.querySelector(".play-button");
  const iframe = el.querySelector(".iframe-youtube");
  const iframeEl = el.querySelector(".iframe-container");
  const videoType = el.querySelector(".video-embed-type");

  const ytUrl = iframeEl.dataset.youtubeUrl;

  let replaceAble = "https://www.youtube.com/watch?v=";

  if (videoType.classList.contains("is-youtube-shorts")) {
    replaceAble = "https://www.youtube.com/shorts/";
  }

  const videoId = ytUrl.replace(replaceAble, "");
  iframe.src = `https://www.youtube.com/embed/${videoId}`;

  iframeEl.addEventListener("click", () => {
    playHide(button, iframe, iframeEl);
  });
};

const videoIframe = (classData) => {
  const elems = document.querySelectorAll(classData);
  classExists(elems);

  elems.forEach((el) => {
    iframeHandler(el);
  });
};

const swiperHandler = (swiperBig, swiperGallery, nextEl, prevEl) => { 

  const galleryMultimedia = new Swiper(swiperGallery, {
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    spaceBetween: 8,
    breakpoints: {
      768: {
        spaceBetween: 16,
      },
    },
  });

  const galleryMultimedia2 = new Swiper(swiperBig, {
    modules: [Navigation, Thumbs],
    spaceBetween: 8,
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    thumbs: {
      swiper: galleryMultimedia,
    },
  });
}

const swiperMultimedia = () => {
  const swipers = document.querySelectorAll('.js-multimedia-gallery');

  classExists(swipers);

  swipers.forEach(element => {
    const swiperBig = element.querySelector('.swiper-big');
    const swiperGallery = element.querySelector('.swiper-gallery');
    const nextEl = element.querySelector('.gall-next');
    const prevEl = element.querySelector('.gall-prev');

    // Pass actual DOM elements
    swiperHandler(swiperBig, swiperGallery, nextEl, prevEl);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  videoIframe(".js-video-iframe");
  swiperMultimedia();
});

export { videoIframe };
